// extracted by mini-css-extract-plugin
export default {"mapbox":"Map_mapbox__K2xB6"};